import { Link } from 'react-router-dom';

// Franchisee-facing "What's new in 1.1" release notes, linked from the
// VersionBanner. Plain-language, benefit-first descriptions of the features
// shipped in this release.
export default function WhatsNew() {
  return (
    <div className="whats-new">
      <div className="whats-new-inner">
        <Link to="/" className="whats-new-back">
          ← Back to dashboard
        </Link>

        <header className="whats-new-header">
          <span className="whats-new-badge">Version 1.1</span>
          <h1>What&rsquo;s new</h1>
          <p className="whats-new-lede">
            Here&rsquo;s what we&rsquo;ve added to your marketing dashboard in this release.
          </p>
        </header>

        {/* 1. Webform leads */}
        <section className="whats-new-item">
          <h2>Your web form leads, alongside your calls</h2>
          <p>
            The <strong>Call Tracking</strong> tab is now called <strong>Calls &amp; Leads</strong>,
            and it has two sub-tabs: <strong>Call Tracking</strong> and{' '}
            <strong>Webform Leads</strong>. Every inquiry submitted through the contact and
            &ldquo;request a consultation&rdquo; forms on your Amada website is now mirrored into the
            dashboard each night and automatically matched to your territory.
          </p>
          <p>
            That means the phone calls and the web form inquiries for your location finally live in
            one place, so you can see the full picture of the leads your marketing is generating —
            no more logging into WordPress to check who filled out a form.
          </p>
        </section>

        {/* 2. CSV export */}
        <section className="whats-new-item">
          <h2>Download your leads as a spreadsheet</h2>
          <p>
            Both the <strong>Call Tracking</strong> and <strong>Webform Leads</strong> sections now
            have a <strong>⬇ Download CSV</strong> button. One click exports your leads to a
            spreadsheet you can open in Excel or Google Sheets.
          </p>
          <p>
            On the Call Tracking side, the export respects whatever filters you have applied, so you
            can download exactly the set of calls you&rsquo;re looking at. Use it to work your leads,
            build a follow-up list, or share results with your team.
          </p>
        </section>

        {/* 3. Ad Match tab */}
        <section className="whats-new-item">
          <h2>A rebuilt Ad Match Amount(s) tab</h2>
          <p>
            The <strong>Ad Match Amount(s)</strong> tab has been reorganized into clear, at-a-glance
            boxes — <strong>Paid Campaign Spend Match</strong>, <strong>Territory Breakdown</strong>,
            and two brand-new programs:
          </p>

          <div className="whats-new-sub">
            <h3>Qualified Lead Program</h3>
            <p>
              We now help cover the cost of your <em>A Place for Mom</em> leads. Amada matches{' '}
              <strong>50%</strong> of your lead cost — currently about <strong>$29</strong> of the{' '}
              <strong>$58</strong> per lead — up to a monthly cap that scales with each
              territory&rsquo;s annualized revenue. The tab shows exactly how many matched leads per
              month you&rsquo;re eligible for and the maximum monthly amount we&rsquo;ll cover, plus
              who to contact to enroll.
            </p>
          </div>

          <div className="whats-new-sub">
            <h3>Paid Campaign Budget Allocation</h3>
            <p>
              You can now tell us how you&rsquo;d like each territory&rsquo;s paid ad budget split
              between channels. Google Ads is the default; drag the slider to shift some of your
              budget toward <strong>Meta</strong> (Facebook &amp; Instagram), and the pie chart
              updates to match. When you save, our marketing team is automatically notified so they
              can update your campaigns — nothing changes in your ad accounts until they do.{' '}
              <strong>YouTube</strong> and <strong>TikTok</strong> are coming soon.
            </p>
          </div>
        </section>

        <footer className="whats-new-footer">
          <Link to="/" className="whats-new-back">
            ← Back to dashboard
          </Link>
        </footer>
      </div>
    </div>
  );
}
